module.exports = __webpack_public_path__ + "static/media/sortup-default.dcf4f7bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/sortup-default.svg
// module id = 957
// module chunks = 0